/* global $ */

$(function () {
    function refreshOsmPlacement() {
        if (
            typeof window.Klarna !== 'undefined'
            && 'OnsiteMessaging' in window.Klarna
            && 'refresh' in window.Klarna.OnsiteMessaging
        ) {
            window.Klarna.OnsiteMessaging.refresh();
        }
    }

    function updateOsmPlacement(amount, selector) {
        var klarnaPlacements = document.querySelectorAll(selector);
        if (amount && klarnaPlacements.length > 0) {
            klarnaPlacements.forEach(function (klarnaPlacement) {
                klarnaPlacement.setAttribute('data-purchase-amount', amount);
            });
        }
        refreshOsmPlacement();
    }

    // product view events
    $('body').on('product:afterAttributeSelect', function (e, response) {
        try {
            var amount = response.data.product.price.sales.value ?? null;
            updateOsmPlacement(Math.round(amount * 100), '.kosm-pdp klarna-placement');
        } catch (e) {
            // prevent other stuff breaks
        }
    });

    // cart/minicart events
    $('body').on('cart:afterUpdateCartTotals', function (e, data) {
        try {
            var amount = data.totals.klarnaTotal ?? null;
            updateOsmPlacement(amount, '.kosm-cart klarna-placement, .kosm-minicart klarna-placement');
        } catch (e) {
            // prevent other stuff breaks
        }
    });

    // mini cart update event
    $('body').on('minicart:afterUpdate', function (e, data) {
        try {
            updateOsmPlacement(null, null);
        } catch (e) {
            // prevent other stuff breaks
        }
    });
});
